import { Component, OnInit } from '@angular/core';
import { AdalService } from 'app/services/adal.service';

@Component({
  selector: 'app-login',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  password: string;
  userName: string;
  errorMsg: string;

  constructor(private adalService : AdalService) {
    this.adalService.logout();
   }

  ngOnInit() {
    
  }

  logout(){

    this.adalService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts